import { SEO } from '@/components/SEO'
import ContactForm from '@/components/contact/ContactForm'

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us - WithWords"
        description="Get in touch with the WithWords team. We're here to help with any questions about our semantic SEO and topical authority platform."
      />
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold tracking-tight mb-3">Get in Touch</h1>
            <p className="text-xl text-muted-foreground">
              Have questions about WithWords? We're here to help.
            </p>
          </div>

          <div className="bg-card rounded-lg shadow-lg p-6 md:p-8">
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  )
}